import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Heart } from 'lucide-react';
import { heroContent } from '../data/mock';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroContent.heroImage}
          alt="Kibouor Foundation"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center text-white">
        <div className="animate-fade-in-up">
          <h1 className="font-playfair text-6xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight">
            {heroContent.tagline}
          </h1>
          <p className="text-2xl md:text-3xl font-light mb-4 text-amber-100">
            {heroContent.subtitle}
          </p>
          <p className="text-lg md:text-xl mb-12 text-gray-200 max-w-2xl mx-auto">
            {heroContent.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="lg"
              className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-6 text-lg font-medium transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
              onClick={() => document.getElementById('donate')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <Heart className="mr-2 h-5 w-5" />
              Donate Now
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white hover:bg-white/20 px-8 py-6 text-lg font-medium transition-all duration-300"
              onClick={() => document.getElementById('homes')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Sponsor a Home
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-white/70 rounded-full mt-2 animate-scroll"></div>
        </div>
      </div>
    </section>
  );
};